import { PLACEHOLDER } from "constants/baseStyle";
import { HTTP_METHOD, POST_NOTICE_FETCH } from "constants/pathConstant";
import { useMutationCustom } from "hooks/useMutationCustom";
import { useToastCustom } from "hooks/useToastCustom";
import { useEffect, useState } from "react";
import { Search, Wrapper } from "template/SearchTemplate.style";
import domainColumn from "../noticeDomainColumn.json";

// 고객 지원 -> 공지 관리 :: 공지 조회 (http://localhost:3000/super/create/notice)
const NoticeSearch = ({
  setNoticeList,
  setPage,
  currentPage,
  pageSize,
  setChecked,
  setSearchData,
}) => {
  const toast = useToastCustom();

  const [title_kr, setTtitle_kr] = useState("");
  const [crtId, setCrtId] = useState("");
  const [alertYn, setAlertYn] = useState("");
  const [reqType, setrReqType] = useState("");

  const { mutate } = useMutationCustom(POST_NOTICE_FETCH, HTTP_METHOD.POST);

  const fetchData = () => {
    const data = {
      title_kr,
      crtId,
      alertYn,
      currentPage,
      pageSize,
      reqType,
    };

    setSearchData(data);

    mutate(data, {
      onSuccess: (res) => {
        setNoticeList(res);
        setChecked([]);
      },

      onError: () => {
        toast("데이터 조회 실패", "error");
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, [pageSize, currentPage]);

  const handleSearch = () => {
    setPage(1);
    fetchData();
  };

  const handleEnter = (key) => {
    if (key === "Enter") handleSearch();
  };

  return (
    <Wrapper>
      <Search.Text>공지 조회</Search.Text>
      <Search.Container>
        <Search.Content>
          {/* 제목/설명 */}
          <Search.InputWrapper>
            <div>제목</div>
            <Search.Input
              placeholder={PLACEHOLDER.SOME}
              onChange={(e) => setTtitle_kr(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          {/* 작성자 */}
          <Search.InputWrapper>
            <div>작성자</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setCrtId(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          <Search.InputWrapper>
            <div>앱 구분</div>
            <Search.Select onChange={(e) => setrReqType(e.target.value)}>
              <Search.Option value={""}>전체</Search.Option>
              {Object.entries(domainColumn.reqType).map(([key, value]) => (
                <Search.Option key={key} value={key}>
                  {value}
                </Search.Option>
              ))}
            </Search.Select>
          </Search.InputWrapper>

          <Search.InputWrapper>
            <div>알림 여부</div>
            <Search.Select onChange={(e) => setAlertYn(e.target.value)}>
              <Search.Option value={""}>전체</Search.Option>
              {Object.entries(domainColumn.alertYn).map(([key, value]) => (
                <Search.Option key={key} value={key}>
                  {value}
                </Search.Option>
              ))}
            </Search.Select>
          </Search.InputWrapper>
        </Search.Content>

        {/* 조회 버튼 */}
        <Search.Btn onClick={handleSearch}>조회</Search.Btn>
      </Search.Container>
    </Wrapper>
  );
};

export default NoticeSearch;
